import { useEffect, useState, useRef, useContext, useCallback } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { SocketContext } from '../context/SocketContext';


import { useHideMenu } from '../hooks/useHideMenu';
import LoadingOverlay from '../components/LoadingOverlay'


import logoParaTicket from "../assets/femcc-01/logoParaTicket.png";
import logo from "../assets/logo.png";
import { Collapse } from 'react-bootstrap';
import { serverApi } from '../api';
import { SelectElement } from '../components/selectElement';

let codigoEntidad = localStorage.getItem('codigoEntidad') || null;
let codigoUbicacion = localStorage.getItem('ubicacion') || null;

const tiposDocumentoLabels = {
    RC: "Registro Civil",
    TI: "Tarjeta de Identidad",
    CC: "Cédula de Ciudadanía",
    CE: "Cédula de Extranjería",
    PE: "Permiso Especial de Permanencia",
    PT: "Permiso por Protección Temporal"
};

const MySwal = withReactContent(Swal);


export const CrearTicket = () => {

    const [formData, setFormData] = useState({
        codigoEntidad: 'femcc-01',
        codigoUbicacion: '',
        tipoDocumento: 'CC',
        numeroDocumento: ''
    });


    useHideMenu(true);

    const [entidadStorage, setEntidadStorage] = useState(
        localStorage.getItem('codigoEntidad') || null
    );
    const [ubicaciones, setUbicaciones] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [tipoAtencion, setTipoAtencion] = useState([])
    const [numeroPantalla, setNumeroPantalla] = useState(1);

    const [numeroDocumentoPaso, setNumeroDocumentoPaso] = useState("");
    const [pacientePaso, setpacientePaso] = useState("");

    const [isTouched, setIsTouched] = useState(false);
    const timeoutRef = useRef(null);

    const { conectarSocket } = useContext(SocketContext);


    const handleInputChange = (e) => {
        const newValue = e.target.value;

        setFormData((prev) => ({
            ...prev,
            [e.target.id]: newValue
        }));
    };

    const fetchUbicaciones = useCallback(async (codigo) => {
        if (!codigo || codigo.trim().length < 3) return;

        try {
            const resp = await serverApi.post(
                `/auth/select-ubicacion-pantallas`,
                { codigoEntidad: codigo.trim() }
            );

            if (!resp.data.ubicaciones || resp.data.ubicaciones.length === 0) return;

            const data = resp.data.ubicaciones.map((item) => ({
                value: item.codigoUbicacion,
                label: item.nombreUbicacion
            }));

            setUbicaciones(data);
        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        }
    }, []);

    // Dispara la búsqueda de sedes automáticamente al montar o al cambiar el código
    useEffect(() => {
        if (formData.codigoEntidad && formData.codigoEntidad.trim().length >= 3) {
            fetchUbicaciones(formData.codigoEntidad.trim());
        }
    }, [formData.codigoEntidad, fetchUbicaciones]);

    const handleTouchStart = () => {
        // Inicia un temporizador de 1 segundo
        timeoutRef.current = setTimeout(() => {
            setIsTouched(true);
        }, 500);
    };

    const handleTouchEnd = () => {
        // Limpia el timeout y remueve efecto
        clearTimeout(timeoutRef.current);
        setIsTouched(false);
    };

    const sweet = (title, html, icon) => {
        MySwal.fire({
            title,
            html,
            showConfirmButton: false,
            timer: 15000
        })
    }

    const iconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="22" fill="#22C55E" />
            <path d="M18 10 C14 4, 6 10, 10 16" fill="#22C55E"/>
            <path d="M46 10 C50 4, 58 10, 54 16" fill="#22C55E"/>
            <rect x="18" y="50" width="6" height="6" rx="2" fill="#22C55E"/>
            <rect x="40" y="50" width="6" height="6" rx="2" fill="#22C55E"/>
            <rect x="30" y="20" width="4" height="16" rx="2" fill="white"/>
            <circle cx="32" cy="42" r="3" fill="white"/>
        </svg>
    `;



    const ingresar = async () => {


        if (formData.codigoUbicacion === "" || formData.codigoEntidad === "") return sweet("Atención!", 'Falta información', 'error');

        await serverApi.post(
            `/auth/registro-pantallas`,
            formData
        );
        localStorage.setItem('codigoEntidad', formData.codigoEntidad);
        localStorage.setItem('codigoUbicacion', formData.codigoUbicacion);
        setEntidadStorage(formData.codigoEntidad);

        conectarSocket({
            query: {
                codigoEntidad: formData.codigoEntidad,
                ubicacion: formData.codigoUbicacion,

            }
        });

        const datos = {
            codigoEntidad: formData.codigoEntidad,
            codigoUbicacion: formData.codigoUbicacion,
        }

        try {

            setIsLoading(true)
            const resp = await serverApi.post(`/tipos-atencion/lista-para-ticket`, datos);
            console.log(resp.data.atenciones);

            if (!resp.data.atenciones) return;
            setTipoAtencion(resp.data.atenciones);


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {

        const fetchData = async () => {

            const formData = {
                codigoEntidad: localStorage.getItem("codigoEntidad"),
                codigoUbicacion: localStorage.getItem("codigoUbicacion"),
            }

            try {

                setIsLoading(true)
                const resp = await serverApi.post(`/tipos-atencion/lista-para-ticket`, formData);
                console.log(resp.data.atenciones);

                if (!resp.data.atenciones) return;
                setTipoAtencion(resp.data.atenciones);


            } catch (error) {
                console.error("Error al obtener ubicaciones", error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();

    }, [])


    // const continuar = () =>{

    //     let documento= formData.numeroDocumento;
    //     let tipoDocumento= formData.tipoDocumento;
    //     if( documento === "" ||tipoDocumento === "") return sweet("Atención!", 'Falta información', 'error');

    //     setPantalla(!pantalla);
    // }

    const pasoPantalla = async (numeroPantalla) => {




        if (numeroPantalla === 1) return setNumeroPantalla(numeroPantalla)


        if (numeroPantalla === 2) {

            let numeroDocumento = formData.numeroDocumento;
            let tipoDocumento = formData.tipoDocumento;

            if (!tipoDocumento || !numeroDocumento) {
                return sweet("Atención!", 'Por favor complete el tipo y número de documento', 'error');
            }

            const data = {
                codigoEntidad,
                numeroDocumento,
            }

            try {

                setIsLoading(true)
                const resp = await serverApi.post(`/tickets/busca-paciente`, data);
                console.log(resp);

                if (!resp.data.paciente) return;

                resp.data.paciente.length === 0
                    ? setpacientePaso("")
                    : setpacientePaso(resp.data.paciente[0].paciente);

                setNumeroDocumentoPaso(numeroDocumento);
                // console.log("tipoAtencion");
                // console.log(tipoAtencion);

                setNumeroPantalla(numeroPantalla);


            } catch (error) {
                console.error("Error al obtener ubicaciones", error);
            } finally {
                setIsLoading(false);
            }



        }

        if (numeroPantalla === 3) {

            console.log(pacientePaso);

        }



        setNumeroPantalla(numeroPantalla);
    }

    const nuevoTicket = async (tipoAtencionSeleccionado, uidTipoAtencion) => {

        // setTimeout(() => {
        // }, 500);

        codigoEntidad = localStorage.getItem('codigoEntidad') || null;
        codigoUbicacion = localStorage.getItem('codigoUbicacion') || null;
        // if(codigoEntidad=== null) location.reload(); 



        const image = new Image();
        image.src = await logoParaTicket;
        image.style.width = "60%";

        let tipoDocumento = formData.tipoDocumento;
        let numeroDocumento = formData.numeroDocumento;
        if (tipoDocumento === "" || numeroDocumento === "") return sweet("Atención!", 'Falta información', 'error');

        let chkPrioridad = document.getElementById("chkPrioridad");
        let indPrioridad = chkPrioridad.checked ? 1 : 0;

        const data = {
            codigoEntidad,
            codigoUbicacion,
            uidTipoAtencion,
            indPrioridad,
            tipoDocumento,
            numeroDocumento,
        }

        try {

            setIsLoading(true)
            const resp = await serverApi.post(`/tickets/crear-ticket`, data);
            const result = await resp.data.ticket;
            console.log(result);

            setFormData({
                ...formData,
                numeroDocumento: '',
                tipoDocumento: 'CC'
            })
            chkPrioridad.checked = false;
            indPrioridad = 0;

            sweet('', `
                    <div style="display: flex; flex-direction: column; align-items: center; padding: 5px">
                        ${iconSvg}        
                        <br/>
                        <b>
                            <h2> Turno: ${tipoAtencionSeleccionado} - ${result.numero} </h2>
                            <p>Por favor, esté atento al televisor o al llamado de voz para saber en qué módulo será atendido.</p> 
                            <br/>
                            ¡Gracias por su Atención!
                        </b>
                    </div>
                    `,
                'success'
            );

            // Imprimir Ticket
            const mywindow = window.open('', 'PRINT', 'height=400,width=300');

            mywindow.document.write(`
                    <html>
                        <head>
                        <title>Ticket</title>
                        <style>
                            body{
                                font-family: Arial;
                                text-align:center;
                                width: 58mm;
                                margin:0;
                                padding:10px;
                            }
                            h1,h4,h5,h6{margin:4px 0;}
                            img{width:120px;}
                        </style>
                        </head>
                        <body>
                        <img src="${logoParaTicket}" />
                        <h1>Turno: ${tipoAtencionSeleccionado}-${result.numero}</h1>
                        <h4>Paciente: ${numeroDocumento}</h4>
                        <h5>${result.fecha}</h5>
                        <h6>-- PITSoluciones.com --</h6>
                        </body>
                    </html>
                `);

            mywindow.document.close();


            mywindow.focus();
            mywindow.print();

            setTimeout(() => {
                mywindow.close();
            }, 4000);

            pasoPantalla(1);


        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        } finally {
            setIsLoading(false);
        }


        // setIsLoading(true);
        // socket.emit('solicitar-ticket', { tipoDocumento, documento, indPrioridad, tipoAtencion, codigoEntidad }, ( result ) => {
        //     setIsLoading(false);





        //     // // let image =  new Image();
        //     // // image.src = logo;
        //     // // image.style.width= "50%";
        //     // let mywindow = window.open(logoParaTicket, 'PRINT', 'height=200,width=300');

        //     // mywindow.document.write('<html><head><title> </title></head>');
        //     // mywindow.document.write('<body >');
        //     // mywindow.document.write( image.outerHTML);
        //     // mywindow.document.write('<h1> Turno: '+ tipoAtencion+"-"+ result.numero  + '</h1>');
        //     // mywindow.document.write('<h4> Paciente: '+ documento  + '</h4>');
        //     // mywindow.document.write('<h5> '+ result.fecha  + '</h5>');
        //     // mywindow.document.write('<h6 style="text-align:end"> -- PITSoluciones.com -- </h6>');
        //     // mywindow.document.write('</body>');
        //     // mywindow.document.write('</html>');

        //     // mywindow.document.close(); // necessary for IE >= 10 
        //     // mywindow.focus(); // necessary for IE >= 10*/

        //     // const myTimeout = setTimeout( () =>{

        //     //     // try {
        //     //         mywindow.print();
        //     //         mywindow.close();
        //     //         clearTimeout(myTimeout);

        //     // }, 700);



        // });
    }

    // const cancelarTicket = () =>{

    //     let numeroDocumento = document.getElementById('numeroDocumento');
    //     numeroDocumento.value = "";
    //     let selectDocumento = document.getElementById("tipoDocumento");
    //     selectDocumento.value = ""


    //     let chkPrioridad = document.getElementById("chkPrioridad");
    //     chkPrioridad.checked = false;

    //     setPantalla(!pantalla);

    // }

    const insertaNumero = (numero) => {
        let numeroDocumento = document.getElementById("numeroDocumento");
        if (numeroDocumento.value.length >= 12) return false;

        numeroDocumento.value += numero;
    }

    const borrarNumero = () => {
        let numeroDocumento = document.getElementById("numeroDocumento");

        numeroDocumento.value = numeroDocumento.value.slice(0, -1);

    }



    if (entidadStorage === null) {
        return (
            <div className="login-container d-flex align-items-center justify-content-center p-3" style={{ minHeight: "100vh", backgroundColor: '#f4f7f6' }}>
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="card shadow-lg border-0 rounded-4 overflow-hidden" style={{ backgroundColor: '#ffffff' }}>
                        <div className="p-4 text-white text-center" style={{ background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)' }}>
                            <div className="d-inline-flex align-items-center justify-content-center mb-2 rounded-circle" style={{ width: 56, height: 56, background: 'rgba(255,255,255,0.15)' }}>
                                <i className="fa-solid fa-[#14b8a6] fa-ticket fs-3" style={{ color: '#14b8a6' }}></i>
                            </div>
                            <h4 className="fw-bold m-0" style={{ letterSpacing: '0.5px' }}>Kiosko de Turnos</h4>
                            <p className="mb-0 opacity-75 small">Configurar Entidad y Sede del Kiosko</p>
                        </div>

                        <div className="p-4">
                            <div className="mb-3">
                                <label htmlFor="codigoEntidad" className="form-label small fw-bold text-secondary">Código de Entidad / Empresa</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="fa-solid fa-building" style={{ color: '#0d7367' }}></i>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 ps-0 shadow-none"
                                        id="codigoEntidad"
                                        placeholder="Ej: femcc-01"
                                        value={formData.codigoEntidad}
                                        onChange={handleInputChange}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>

                            {ubicaciones.length > 0 &&
                                <div className='mb-4'>
                                    <label htmlFor="codigoUbicacion" className="form-label small fw-bold text-secondary">Sede / Ubicación</label>
                                    <SelectElement
                                        options={ubicaciones}
                                        id={"codigoUbicacion"}
                                        name={"codigoUbicacion"}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        className={"shadow-sm rounded-3"}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }

                            {formData.codigoUbicacion && (
                                <button
                                    className="btn w-100 py-3 fw-bold text-white shadow-sm rounded-3 transition-all mt-2"
                                    type="button"
                                    onClick={ingresar}
                                    style={{ background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)', border: 'none' }}
                                >
                                    INGRESAR AL KIOSKO →
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );

    } else {

        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={` ${isLoading ? 'opacity' : ''} p-md-5 p-3`} style={{ height: '100dvh' }}>

                    <div className="d-grid gap-2 mt-2 mx-auto text-center w-100 mb-3" >
                        <img id="imgPrint" className='img-fluid mx-auto d-block w-sm-50 w-md-30' style={{ height: 'auto' }} src={logo} alt='' />
                    </div>



                    <div className='row content bg-light rounded-3' >

                        <Collapse in={numeroPantalla === 1}>
                            <div className='row p-md-5 p-1 '>

                                <div className='col-lg-6 col-12 text-center mb-5'>

                                    <div className='ms-4 text-start col-12 px-4'>
                                        <label className='form-label text-muted fs-3' >Ingrese los datos del paciente para recibir el turno:</label>
                                    </div>
                                    <div className="card shadow-lg p-4 col-10 d-inline-block text-start justify-content-center" style={{ border: '0px', borderRadius: '15px', margin: 'auto' }}>

                                        <div className='card-body p-2 ' >


                                            <div className='col-12 '>

                                                <div className='mb-5'>
                                                    <label className='form-label text-muted fs-3' >Tipo de documento</label>
                                                    <div className="input-group">
                                                        <span
                                                            className="input-group-text  text-body-tertiary bg-white border-0 border-bottom rounded-0"
                                                            style={{ borderBottom: '1px solid #eeeeee' }}
                                                        >
                                                            {/* <i className="bi bi-person-vcard text-body-tertiary"></i> */}
                                                            <i className="far fa-address-card text-body-tertiary fs-3" ></i>
                                                        </span>
                                                        <select
                                                            id="tipoDocumento"
                                                            className="form-select border-0 border-bottom rounded-0 fs-3"
                                                            style={{ borderBottom: '1px solid #eeeeee' }}
                                                            value={formData.tipoDocumento} // Vinculado al estado inicial 'CC'
                                                            onChange={handleInputChange}
                                                        >
                                                            <option value="">Seleccione uno...</option>

                                                            {Object.entries(tiposDocumentoLabels).map(([key, label]) => (
                                                                <option key={key} value={key}>
                                                                    {label}
                                                                </option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                </div>

                                                <div className='mb-5'>
                                                    <label className='form-label text-muted fs-3 mb-0' >Número de documento</label>
                                                    <div className="input-group">
                                                        <span
                                                            className="input-group-text  text-body-tertiary bg-white border-0 border-bottom rounded-0"
                                                            style={{ borderBottom: '1px solid #eeeeee' }}
                                                        >
                                                            0 1 <br />
                                                            2 3
                                                        </span>

                                                        <input
                                                            type='text'
                                                            inputMode="numeric"
                                                            id='numeroDocumento'
                                                            className='form-control border-0 border-bottom rounded-0 fs-3'
                                                            autoComplete='off'
                                                            style={{ borderBottom: '1px solid #eeeeee' }}
                                                            value={formData.numeroDocumento || ''}
                                                            onChange={(e) => {
                                                                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12);
                                                                handleInputChange(e);
                                                            }}
                                                        />

                                                    </div>
                                                </div>


                                            </div>


                                            <div className="d-grid gap-2 col-xl-5 col-12 mx-auto ">
                                                <button
                                                    type="button" className="btn btn-lg btn-success m-1 rounded-5 "
                                                    onClick={() => pasoPantalla(2)}
                                                    style={{ fontSize: '30px' }}
                                                >
                                                    SIGUIENTE
                                                </button>
                                            </div>


                                        </div>

                                    </div>
                                </div>

                                <div className='col-lg-6 col-12 text-start'>

                                    {[
                                        [1, 2, 3],
                                        [4, 5, 6],
                                        [7, 8, 9],
                                        [0]
                                    ].map((fila, idx) => (
                                        <div className="d-flex justify-content-center" key={idx}>
                                            {fila.map(num => (
                                                <button
                                                    key={num}
                                                    type="button"
                                                    className="btn btn-secondary btn-square-md m-1 shadow"
                                                    onClick={() => insertaNumero(num)}
                                                    value={num}
                                                >
                                                    {num}
                                                </button>
                                            ))}
                                            {idx === 3 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-rectangle-md m-1"
                                                    onClick={() => borrarNumero()}
                                                >
                                                    Borrar
                                                </button>
                                            )}
                                        </div>
                                    ))}



                                </div>

                            </div>
                        </Collapse>

                        <Collapse in={numeroPantalla === 2}>

                            <div className='col-12 py-2 fs-4 fw-bold'>

                                <div className='row mb-2'>

                                    <div className="col-1">
                                        <button type="button" className="btn btn-sm btn-danger  m-1" onClick={() => pasoPantalla(1)} > Atrás </button>
                                    </div>

                                    <div className='col-11 text-center'>
                                        <label style={{ color: '#037faf' }}>  {`${numeroDocumentoPaso} ${pacientePaso ? '- ' + pacientePaso : ''}`} </label>
                                    </div>


                                </div>

                                <div className='col-lg-9 col-12 fs-3'>
                                    <label style={{ color: '#7A7A7A' }}> Indíquenos el motivo de su visita: </label>
                                </div>

                                <div className='row mt-1 pb-4' >
                                    <div className="d-flex justify-content-center mt-2">
                                        <div className='d-grid gap-1 col-lg-4 col-12 mx-auto mb-2'>
                                            <input type="checkbox" className="btn-check" id="chkPrioridad" autoComplete="off" />
                                            <label
                                                className="btn btn-lg btn-outline-danger rounded-5 border-1 shadow p-2"
                                                htmlFor="chkPrioridad"
                                                style={{
                                                    fontFamily: "'Inter', sans-serif",
                                                    fontSize: "22px",
                                                    fontWeight: "700", // opcional si quieres variar entre bold y regular

                                                }}
                                            >
                                                <i className="fa-solid fa-wheelchair"></i>
                                                <span className='ml-2'> PRIORIZADO </span>
                                            </label>
                                        </div>
                                    </div>

                                    {tipoAtencion && tipoAtencion.length > 0 &&

                                        tipoAtencion
                                            .map((item, i) => (
                                                <div className='col-lg-6 col-12 d-grid gap-3 mb-2 ' key={item.uidTipoAtencion}>

                                                    <div
                                                        className={
                                                            `
                                                                card m-2 hover-shadow 
                                                                ${isTouched ? 'card-touch-active' : ''}
                                                                rounded-4 shadow-lg
                                                                border-bottom-2 
                                                                min-h-[120px] sm:min-h-[150px] md:min-h-[80px] lg:min-h-[200px]
                                                            `

                                                        }
                                                        style={{ cursor: 'pointer', borderBottomColor: item.color ?? '#000' }}
                                                        onClick={() => nuevoTicket(`${item.codigoTipoAtencion}`, `${item.uidTipoAtencion}`)}
                                                        onTouchStart={handleTouchStart}
                                                        onTouchEnd={handleTouchEnd}
                                                        onTouchCancel={handleTouchEnd}
                                                        role="button"
                                                        tabIndex={0}
                                                    >
                                                        <div className="card-body">
                                                            <div className='row mx-auto p-2'>

                                                                <div className="col-1  d-flex align-items-center justify-content-center">
                                                                    <i
                                                                        className={`${item.icono} fa-3x`}
                                                                        style={{ color: item.color ?? '#000' }}
                                                                    ></i>
                                                                </div>
                                                                <div className="col-11">
                                                                    <div
                                                                        className="d-flex flex-column justify-content-start align-items-start text-start p-2 ms-2 p-2 ms-2"
                                                                        style={{
                                                                            fontFamily: "'Inter', sans-serif",
                                                                            fontSize: "18px",
                                                                            fontWeight: "700", // opcional si quieres variar entre bold y regular

                                                                        }}
                                                                    >
                                                                        <span>
                                                                            {item.tipoAtencion}
                                                                        </span>
                                                                        <span style={{ fontSize: "18px", color: '#7A7A7A', fontWeight: '300' }} >
                                                                            {item.complemento}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            )


                                            )

                                    }




                                </div>




                            </div>

                        </Collapse>

                    </div>







                </div>
            </>

        )

    }

}
